import { ReactNode } from 'react';

export enum ErrorBoxActionType {
    ADD_BOX_WARNING = 'ADD_BOX_WARNING',
    REMOVE_BOX_WARNING = 'REMOVE_BOX_WARNING',
}

export type ErrorBoxAction =
    | {
          type: ErrorBoxActionType.ADD_BOX_WARNING;
          payload: { errorBoxMessage: ReactNode };
      }
    | {
          type: ErrorBoxActionType.REMOVE_BOX_WARNING;
      };
